const CustomFilter = {
	"BAT_UK_INDEPENDENT-CategoryExpansionCore": {
		"Product Handling": {
			FilterType: true,
			"shop_data.core_universe": ["1"]
		},
		shoper_profile: {
			FilterType: true
		},
		FilterType: true,
		tenant: {
			FilterType: true
		}
	},
	"BAT_UK_INDEPENDENT-Expansion Polygons": {
		"Product Handling": {
			FilterType: true,
			"shop_data.selected_universe": ["1"]
		},
		shoper_profile: {
			FilterType: true
		},
		FilterType: true,
		tenant: {
			FilterType: true
		}
	},
	"BAT_UK_INDEPENDENT-White Space": {
		"Product Handling": {
			FilterType: true,
			"shop_data.selected_universe": ["1"]
		},
		shoper_profile: {
			FilterType: true
		},
		FilterType: true,
		tenant: {
			FilterType: true
		}
	},
	"BAT_UK_INDEPENDENT-Comparison": {
		"Product Handling": {
			FilterType: true,
			"shop_data.selected_universe": ["1"]
		},
		shoper_profile: {
			FilterType: true
		},
		FilterType: true,
		tenant: {
			FilterType: true
		}
	},
	"BAT_UK_INDEPENDENT-CategoryComparison": {
		"Product Handling": {
			FilterType: true,
			"shop_data.core_universe": ["1"]
		},
		shoper_profile: {
			FilterType: true
		},
		FilterType: true,
		tenant: {
			FilterType: true
		}
	},
	"BAT_UK_INDEPENDENT-Category White Space": {
		"Product Handling": {
			FilterType: true,
			"shop_data.core_universe": ["1"]
		},
		shoper_profile: {
			FilterType: true
		},
		FilterType: true,
		tenant: {
			FilterType: true
		}
	},
	"BAT_TENNESSEE-Targeted Consumer": {
		shopper_profile: {
			FilterType: true,
			"shop_data.age_groups": ["18-24"],
			"shop_data.ethnicity": ["White"],
			"shop_data.education_level": ["GED certificate"],
			"shop_data.income_levels": ["$75K - $99.99K"],
			"shop_data.gender": ["Male"]
		},
		shop_profile: {
			FilterType: true
		},
		FilterType: true,
		tenant: {
			FilterType: true
		}
	},
	"BAT_JAPAN-shop_data.smoking_area": {
		Shop_Profile: {
			FilterType: true,
			"shop_data.smoking_area": ["Yes"]
		},
		shopper_profile: {
			FilterType: true
		},
		FilterType: true,
		tenant: {
			FilterType: true
		}
	},
	"BAT_JAPAN-shop_data.horeca": {
		Shop_Profile: {
			FilterType: true,
			"shop_data.horeca": ["Yes"]
		},
		shopper_profile: {
			FilterType: true
		},
		FilterType: true,
		tenant: {
			FilterType: true
		}
	}
	// [`${BAT_UK}-${CategorySAWhiteSpace}`]: {
	// 	"Product Handling": {
	// 		FilterType: true,
	// 		"shop_data.sub_category": [
	// 			"Convenience Store",
	// 			"Convenience Stores",
	// 			"Cash & Carry",
	// 			"Department Stores",
	// 			"Discount Store",
	// 			"Greengrocers & Fruitsellers",
	// 			"Grocers",
	// 			"Newsagents",
	// 			"Wholesalers",
	// 			"Drug Store",
	// 			"Beauty Products",
	// 			"Chemists / Toiletries",
	// 			"Health & Beauty Shops",
	// 			"Health Foods & Products",
	// 			"Super Markets",
	// 			"Supermarkets",
	// 			"Vape & Tobacconist",
	// 			"Mobile Phones",
	// 			"Vaping Stores and Tobacconists",
	// 			"Petrol Stations",
	// 			"Petrol Filling Stations"
	// 		]
	// 	},
	// 	shoper_profile: {
	// 		FilterType: true
	// 	},
	// 	FilterType: true,
	// 	tenant: {
	// 		FilterType: true,
	// 		"shop_data.sub_category": {
	// 			key: "shop_data.sub_category",
	// 			dbKey: "outlet_data.category",
	// 			value: true
	// 		}
	// 	}
	// },
	// [`${BAT_UK_INDEPENDENT}-${CategorySAWhiteSpace}`]: {
	// 	"Product Handling": {
	// 		FilterType: true,
	// 		FilterClientShops: {
	// 			key: "shop_data.sub_category",
	// 			dbKey: "outlet_data.category",
	// 			value: true
	// 		},
	// 		"shop_data.sub_category": [
	// 			"Convenience Store",
	// 			"Convenience Stores",
	// 			"Cash & Carry",
	// 			"Department Stores",
	// 			"Discount Store",
	// 			"Fresh Food Grocery Stores",
	// 			"Grocery Stores",
	// 			"Newsagents",
	// 			"Wholesalers",
	// 			"Drug Store",
	// 			"Beauty Products",
	// 			"Pharmacies",
	// 			"Health & Beauty Stores",
	// 			"Health Food Retailers",
	// 			"Super Markets",
	// 			"Supermarkets",
	// 			"Vape & Tobacconist",
	// 			"Mobile Phone Shops",
	// 			"Tobacconists and Vaping Stores",
	// 			"Petrol Stations",
	// 			"Petrol Service Stations"
	// 		]
	// 	},
	// 	shoper_profile: {
	// 		FilterType: true
	// 	},
	// 	FilterType: true,
	// 	tenant: {
	// 		sub_category: {
	// 			key: "shop_data.sub_category",
	// 			dbKey: "outlet_data.category",
	// 			value: true
	// 		}
	// 	}
	// }
};

export default CustomFilter;
